//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import ConditionalBlockModal from "./ConditionalBlock/ConditionalBlockModal.vue";
import RepeatableBlockModal from "./RepeatableBlock/RepeatableBlockModal.vue";
import Vue from "vue";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "./DateFormat/DateFormatPlugin.css";
import "./ConditionalBlock/ConditionalBlockPlugin.css";
import "./RepeatableBlock/RepeatableBlockPlugin.css";
import "froala-editor/js/plugins.pkgd.min";
import VueFroala from "@/assets/js/custom_libs/froala/vue-froala";
import FroalaEditor from "froala-editor";
import Tribute from "tributejs";
import { mapGetters } from "vuex";
import QAuModelPicker from "../../Generics/ModelPicker/qAuModelPicker";
import { addDataTable, formatDataModelVar } from "./DatamodelTable.js";
import { config } from "./FroalaConfig.js";
import { defaultSelectedBlock, defaultSelectedRepeatableBlock } from "./defaultDocument";

Vue.use(VueFroala);
let froalaInstance = null;
let vueInstance = null;
const tributeInterface = {
    showVariables: false
};
const configNotifications = { ...config };
delete configNotifications.fontFamily;

const tribute = new Tribute({
    trigger: "$",
    containerClass: "tribute-menu",
    spaceSelectsMatch: false,
    allowSpaces: false,
    requireLeadingSpace: true,
    selectTemplate() {
        return "";
    },
    values(text, cb) {
        changeFilter(text);
    },
    searchOpts: {
        pre: "",
        post: "",
        skip: true // true will skip local search, useful if doing server-side search
    }
});

function changeFilter(newVal) {
    tributeInterface.showVariables = tribute.isActive;
    vueInstance.datamodelFilter = newVal;
}

export default {
    name: "FroalaNotifications",
    components: {
        QAuModelPicker,
        ConditionalBlockModal,
        RepeatableBlockModal
    },
    props: {
        documentEmail: {
            type: Object,
            default: () => ({
                id: "",
                processDefinitionId: "",
                template: "",
                rules: [],
                repeatableParameters: [],
                blockCounter: 0,
                repeatableBlockCounter: 0
            })
        },
        documentSMS: {
            type: Object,
            default: () => ({
                id: "",
                processDefinitionId: "",
                template: ""
            })
        },
        rules: {
            type: Object,
            default: () => ({})
        },
        readonly: {
            type: Boolean,
            default: false
        },
        hideToolbar: {
            type: Boolean,
            default: false
        },
        isFromExternal: {
            type: Boolean,
            default: false
        },
        selectedTab: String,
        emailOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedBlock: defaultSelectedBlock(),
            selectedRepeatableBlock: defaultSelectedRepeatableBlock(),
            showModal: false,
            showRepeatableModal: false,
            tableTop: 0,
            tableLeft: 0,
            offsetY: 0,
            offsetX: 0,
            datemenuTop: 0,
            datemenuLeft: 0,
            tablePickerOpen: false,
            tributeInterface,
            showVariables: false,
            showStaticPicker: false,
            showDateMenu: false,
            datamodelFilter: "",
            pageFormat: "",
            showBlocks: false,
            textDirections: ["ltr", "rtl"],
            currentBeforeBlur: null,
            editable: true,
            dataModelConstraint: "",
            disableButton: {
                repeatableBlock: false,
                conditionalBlock: false
            },
            configNotifications: {
                ...configNotifications,
                scrollableContainer: ".froala-notifications",
                toolbarButtons: {
                    moreText: {
                        buttons: [
                            "fontFamily",
                            "fontSize",
                            "bold",
                            "italic",
                            "underline",
                            "paragraphFormat",
                            "textColor",
                            "paragraphStyle",
                            "strikeThrough",
                            "subscript",
                            "superscript",
                            "backgroundColor",
                            "clearFormatting"
                        ],
                        buttonsVisible: 5,
                        align: "left"
                    },
                    moreParagraph: {
                        buttons: ["alignLeft", "alignCenter", "alignRight", "alignJustify", "lineHeight", "formatUL", "formatOL", "indent", "outdent", "quote"],
                        buttonsVisible: 5,
                        align: "left"
                    },
                    moreRich: {
                        buttons: [
                            "conditionalBlock",
                            "repeatableBlock",
                            "insertTable",
                            "dynamicTable",
                            "insertLink",
                            "insertImage",
                            "specialCharacters",
                            "insertHR"
                        ],
                        buttonsVisible: 3,
                        align: "left"
                    },
                    moreMisc: {
                        buttons: [
                            "html",
                            "undo",
                            "redo",
                            "toggleBlocks",
                            "pastePlainText",
                            "directionLTR",
                            "directionRTL",
                            "fullscreen",
                            "spellChecker",
                            "selectAll",
                            "help"
                        ],
                        align: "left",
                        buttonsVisible: 5
                    }
                },
                imageEditButtons: ["imageRemove", "|", "imageLink", "linkOpen", "linkEdit", "linkRemove", "imageDisplay", "-", "imageAlt", "imageSize"],
                events: {
                    initialized() {
                        froalaInstance = this;
                        this.vueInstance = vueInstance;
                        tribute.attach(this.el);
                        this.opts.imageUploadParams = { isNotification: true };
                        this.opts.imageUploadURL = `/documents/templates/${this.vueInstance.documentEmail.id}/image/upload/`;
                        if (this.vueInstance.selectedTab && this.vueInstance.selectedTab === "sms" && vueInstance.emailOnly) {
                            froalaInstance.toolbar.show();
                        } else if (this.vueInstance.selectedTab && this.vueInstance.selectedTab === "sms" && !vueInstance.emailOnly) {
                            froalaInstance.toolbar.hide();
                        } else if (!this.vueInstance.selectedTab && this.vueInstance.hideToolbar) {
                            froalaInstance.toolbar.hide();
                        }
                        if (vueInstance.readonly) {
                            vueInstance.editable = false;
                        } else {
                            vueInstance.editable = true;
                        }
                        this.events.on(
                            "keydown",
                            ev => {
                                if (tribute.isActive) {
                                    vueInstance.currentBeforeBlur = tribute.current;
                                    tributeInterface.showVariables = true;
                                } else {
                                    tributeInterface.showVariables = false;
                                }
                                if (
                                    tribute.isActive &&
                                    (ev.which == 13 || // enter
                                    ev.which == 37 || // arrow left
                                    ev.which == 38 || // arrow up
                                    ev.which == 39 || // arrow right
                                        ev.which == 40) // arrow down
                                ) {
                                    ev.stopPropagation();
                                    ev.preventDefault();
                                    vueInstance.$refs.DMPicker.$refs.modelTree.keyPress(ev);
                                    return false;
                                }
                            },
                            true
                        );
                    },
                    input() {
                        this.events.trigger("contentChanged");
                    },
                    blur() {
                        this.selection.save();
                        vueInstance.currentBeforeBlur = tribute.current;
                    },
                    focus() {
                        tribute.isActive = false;
                        tributeInterface.showVariables = false;
                    },
                    contentChanged() {
                        if (tribute.isActive) {
                            this.selection.save();
                            vueInstance.currentBeforeBlur = tribute.current;
                            tributeInterface.showVariables = true;
                        } else {
                            tributeInterface.showVariables = false;
                        }
                        this.events.focus();
                    },
                    updateRepeatableBlock(name, uid, parentUuid) {
                        vueInstance.selectedRepeatableBlock = vueInstance.getCurrentRepeatable(uid) || {
                            name,
                            uid,
                            parentUuid,
                            selection: [],
                            sortBy: "",
                            direction: "",
                            statement: "",
                            conditions: []
                        };
                        vueInstance.filterRepeatable = [...vueInstance.selectedRepeatableBlock.selection];
                    },
                    click(clickEvent) {
                        const $target = this.$(clickEvent.target);
                        if ($target.parentsUntil(this.$el, "table").length > 0) {
                            vueInstance.disableButton.repeatableBlock = true;
                        } else if (!vueInstance.readonly && !$target.hasClass("fr-tribute") && !$target.hasClass("DML") && !$target.hasClass("VAR")) {
                            vueInstance.disableButton.repeatableBlock = false;
                        }
                        if (
                            !$target.hasClass("conditional-block") &&
                            ($target.hasClass("repeatable-block") || $target.parentsUntil(".fr-view, .conditional-block", ".repeatable-block").length > 0)
                        ) {
                            this.repeatableBlockPlugin.showPopup(clickEvent, true);
                            this.repeatableBlockPlugin.setVisible(true);
                            this.repeatableBlockPlugin.clickBlock(clickEvent);
                            if ($target.hasClass("repeatable-block") || $target.hasClass("repeatable-inner")) {
                                vueInstance.filterRepeatable = [];
                            }
                            if (vueInstance.selectedRepeatableBlock.selection[0]) {
                                vueInstance.basePath = `m_${vueInstance.selectedRepeatableBlock.selection[0]}`;
                            } else {
                                vueInstance.basePath = "";
                            }
                            this.toolbar.enable();
                        } else {
                            vueInstance.selectedRepeatableBlock = {
                                name: "",
                                uuid: "",
                                parentUuid: "",
                                selection: [],
                                sortBy: "",
                                direction: "",
                                statement: "",
                                conditions: []
                            };
                            vueInstance.filterRepeatable = [];
                            vueInstance.basePath = "";
                        }
                        if (
                            !$target.hasClass("repeatable-block") &&
                            ($target.hasClass("conditional-block") || $target.parentsUntil(".fr-view, .repeatable-block", ".conditional-block").length > 0)
                        ) {
                            this.conditionalBlockPlugin.showPopup(clickEvent, true);
                            this.toolbar.enable();
                        }
                        if ($target.hasClass("fr-tribute") || $target.parent().hasClass("fr-tribute")) {
                            if (this.selection.get().type === "Range") {
                                this.toolbar.enable();
                            } else {
                                setTimeout(() => {
                                    this.fromatDatePlugin.showPopup();
                                }, 0);
                            }
                        }
                        if (
                            !$target.hasClass("repeatable-block") &&
                            ($target.hasClass("conditional-block") || $target.parentsUntil(".fr-view, .repeatable-block", ".conditional-block").length > 0)
                        ) {
                            setTimeout(() => {
                                this.conditionalBlockPlugin.setVisible(true);
                            }, 0);
                        }
                        if (
                            this.$el
                                .children()
                                .last()
                                .is(".conditional-block, .repeatable-block") ||
                            this.$el
                                .children()
                                .last()
                                .children()
                                .last()
                                .is(".conditional-block, .repeatable-block")
                        ) {
                            this.$el.append("<p><br></p>");
                        }
                        tribute.isActive = false;
                        tributeInterface.showVariables = false;
                        vueInstance.tablePickerOpen = false;
                    },
                    "commands.mousedown": function(btn) {
                        if (btn[0].id.indexOf("dynamicTable") === -1) {
                            vueInstance.tablePickerOpen = false;
                        }
                    },
                    "commands.before": function(cmd) {
                        let $selectionInBLock = this.$(this.selection.element());
                        if (!$selectionInBLock.hasClass("conditional-block")) {
                            $selectionInBLock = $selectionInBLock.parentsUntil(this.$el, ".conditional-block");
                        }
                        if ($selectionInBLock.length) {
                            $selectionInBLock.addClass("setEditableFalse").removeAttr("contenteditable");
                        }
                    },
                    "commands.after": function(cmd) {
                        if (cmd === "tableRemove") {
                            vueInstance.disableButton.repeatableBlock = false;
                        }
                        this.$el
                            .find(".setEditableFalse")
                            .attr("contenteditable", "false")
                            .removeClass("setEditableFalse");
                    },
                    "table.inserted": function(newTable) {
                        vueInstance.disableButton.repeatableBlock = true;
                        const blockParents = this.$(newTable).parentsUntil(this.$el, ".conditional-block");
                        const firstBlockParent = blockParents.first();
                        if (firstBlockParent && !firstBlockParent.hasClass("blkel")) {
                            newTable = this.$(newTable);
                            newTable.wrap('<div style="display: block" contenteditable="true" class="conditional-inner"></div>');
                            const sections = firstBlockParent.find(".conditional-inner");
                            const { $ } = this;
                            let $firstChild = null;
                            sections.each(function(index) {
                                const $this = $(this);
                                if (index === 0) {
                                    $firstChild = $this;
                                } else {
                                    $firstChild.append($this.html());
                                    $this.remove();
                                }
                            });
                        }
                    }
                }
            }
        };
    },
    computed: {
        ...mapGetters("diagrams", ["getExternalDraftDataEmail", "getExternalDraftDataSMS", "getExternalDraftDataEmailAuth"]),
        currentDoc() {
            return (
                (this.hideToolbar ? this.documentSMS : this.documentEmail) || {
                    id: uid(),
                    processDefinitionId: "",
                    template: "",
                    rules: [],
                    repeatableParameters: [],
                    blockCounter: 0,
                    repeatableBlockCounter: 0
                }
            );
        }
    },
    watch: {
        tributeInterface: {
            handler(newVal) {
                if (newVal.showVariables) {
                    this.refreshMenuPosition();
                    froalaInstance.events.focus();
                }
                if (newVal.showVariables !== this.showVariables) {
                    this.showVariables = newVal.showVariables;
                    froalaInstance.events.focus();
                }
            },
            deep: true,
            immediate: true
        },
        documentEmail: {
            handler(newVal) {
                const { processDefinitionId, id, template, rules, repeatableParameters, blockCounter, repeatableBlockCounter } = newVal;
                if (processDefinitionId === null && id === null) {
                    this.editable = false;
                } else {
                    if (this.isFromExternal) {
                        if (this.selectedTab === "sms") {
                            this.$store.commit("diagrams/setExternalDraftDataEmailAuth", {
                                bodyEmail: template,
                                subject: this.getExternalDraftDataEmailAuth.subject,
                                attachments: this.getExternalDraftDataEmailAuth.attachments,
                                rules,
                                repeatableParameters,
                                blockCounter,
                                repeatableBlockCounter
                            });
                        } else {
                            this.$store.commit("diagrams/setExternalDraftDataEmail", {
                                attachments: this.getExternalDraftDataEmail.attachments,
                                bodyEmail: template,
                                subject: this.getExternalDraftDataEmail.subject,
                                rules,
                                repeatableParameters,
                                blockCounter,
                                repeatableBlockCounter
                            });
                        }
                    }
                    this.editable = true;
                }
            },
            deep: true
        },
        documentSMS: {
            handler(newVal) {
                if (newVal.processDefinitionId === null && newVal.id === null) {
                    this.editable = false;
                } else {
                    this.$store.commit("diagrams/setExternalDraftDataSMS", { smsBoby: newVal.template });
                    this.editable = true;
                }
            },
            deep: true
        },
        readonly: {
            handler(newVal) {
                if (newVal) {
                    this.editable = false;
                } else {
                    this.editable = true;
                }
            }
        },
        editable: {
            handler(newVal) {
                if (newVal) {
                    froalaInstance.edit.on();
                } else {
                    froalaInstance.edit.off();
                }
            }
        }
    },
    created() {
        let { host } = window.location;
        let { protocol } = window.location;
        if (host.indexOf("localhost") !== -1) {
            host = process.env.VUE_APP_ENV_PATH;
            protocol = "https:";
        }
        this.$root.$off("sendElToInsert");
        this.$root.$on("sendElToInsert", newElemment => {
            this.onStaticSelect(newElemment);
            froalaInstance.events.trigger("contentChanged");
        });

        this.$root.$on("resetPicker", () => {
            tribute.isActive = false;
            tributeInterface.showVariables = false;
        });
        this.$root.$off("checkSMS");
        this.$root.$on("checkSMS", (value, emailOnly) => {
            if (value && !emailOnly) {
                froalaInstance.toolbar.hide();
            } else {
                froalaInstance.toolbar.show();
            }
        });
        this.$root.$off("forceSaveEditor");
        this.$root.$on("forceSaveEditor", () => {
            froalaInstance.events.trigger("contentChanged");
        });
        window.addEventListener("popstate", this.exitFullscreen, false);

        vueInstance = this;
        FroalaEditor.RegisterCommand("toggleBlocks", {
            title: "Show blocks",
            focus: true,
            undo: true,
            refreshAfterCallback: true,
            refresh($btn) {
                if (this.opts.showBlocks) {
                    $btn.addClass("fr-active");
                } else {
                    $btn.removeClass("fr-active");
                }
            },
            callback() {
                this.opts.showBlocks = vueInstance.toggleShowBlocks();
            }
        });
        FroalaEditor.RegisterCommand("dynamicTable", {
            title: "Insert table from Data model",
            focus: true,
            undo: false,
            refreshAfterCallback: true,
            callback: () => {
                if (!this.tableTop && !this.tableLeft) {
                    return;
                }
                froalaInstance.selection.save();
                this.tablePickerOpen = !this.tablePickerOpen;
                if (tribute.isActive) {
                    this.showVariables = false;
                    tribute.isActive = false;
                    tributeInterface.showVariables = false;
                }
            },
            refresh: $btn => {
                this.tableTop = $btn[0].getBoundingClientRect().top + 50;
                this.tableLeft = $btn[0].getBoundingClientRect().left;
            },
            refreshOnShow: ($btn, $dropdown) => {
                this.tableTop = $btn[0].getBoundingClientRect().top + 50;
                this.tableLeft = $btn[0].getBoundingClientRect().left;
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener("popstate", this.exitFullscreen, false);
        this.$root.$off("resetPicker");
    },
    methods: {
        updateBlock({ name = "", description = "", uuid = "", statement = "", conditions = [] } = {}) {
            this.selectedBlock.uuid = uuid;
            const currentRule = this.getCurrentRule(uuid);
            if (currentRule) {
                currentRule.statement = statement;
                currentRule.conditions = conditions;
                currentRule.name = name;
                currentRule.description = description;
            } else {
                this.currentDoc.rules.push({
                    uuid,
                    statement,
                    conditions,
                    description,
                    name
                });
            }
            froalaInstance.conditionalBlockPlugin.applySettings({ name, uuid });
            this.showModal = false;
        },
        getFilteredList({ name = "", uuid = "", parentUuid = "", selection = [], sortBy = "", direction = "", statement = "", conditions = [] } = {}) {
            this.selectedRepeatableBlock = {
                uuid,
                name,
                parentUuid,
                selection,
                sortBy,
                direction,
                statement,
                conditions
            };
            const repBlock = this.getCurrentRepeatable(uuid);
            if (repBlock && repBlock.uuid) {
                let currentId = uuid;
                let childBlock = this.currentDoc.repeatableParameters.find(el => el.parentUuid === currentId);
                if (JSON.stringify(repBlock.selection) !== JSON.stringify(selection)) {
                    while (childBlock) {
                        currentId = childBlock.uuid;
                        childBlock.selection = [];
                        childBlock.statement = "";
                        childBlock.conditions = [];
                        // eslint-disable-next-line no-loop-func
                        childBlock = this.currentDoc.repeatableParameters.find(el => el.parentUuid === currentId);
                    }
                }
                repBlock.name = name;
                repBlock.selection = selection;
                repBlock.sortBy = sortBy;
                repBlock.direction = direction;
                repBlock.statement = statement;
                repBlock.conditions = conditions;
            } else {
                this.currentDoc.repeatableParameters.push({
                    uuid,
                    name,
                    parentUuid,
                    selection,
                    sortBy,
                    direction,
                    statement,
                    conditions
                });
            }
            froalaInstance.repeatableBlockPlugin.applySettings({ name, uuid });
        },
        getCurrentRepeatable(uuid) {
            if (!this.currentDoc.repeatableParameters) {
                this.currentDoc.repeatableParameters = [];
            }
            return this.currentDoc.repeatableParameters.find(elem => elem.uuid === uuid);
        },
        getdataModelConstraint() {
            this.dataModelConstraint = "";
            const parent = this.currentDoc.repeatableParameters.filter(el => el.uuid === this.selectedRepeatableBlock.parentUuid);
            if (parent.length) {
                [this.dataModelConstraint] = parent[0].selection;
            }
        },
        getCurrentRule(uuid) {
            if (!this.currentDoc.rules) {
                this.currentDoc.rules = [];
            }
            return this.currentDoc.rules.find(rule => rule.uuid === uuid);
        },
        onStaticSelect(item) {
            froalaInstance.selection.restore();
            froalaInstance.html.insert(`${item}&nbsp;`);
            froalaInstance.selection.save();
            const insertedEl = froalaInstance.$(".last-inserted");
            insertedEl[0].scrollIntoView({ behavior: "smooth", block: "center" });
            insertedEl.removeClass("last-inserted");
        },
        removeBlock(uuid) {
            this.showModal = false;
            froalaInstance.conditionalBlockPlugin.removeBlock(uuid);
            this.deleteRule(uuid);
        },
        deleteRule(uuid) {
            if (!this.currentDoc.rules) {
                this.currentDoc.rules = [];
            }
            this.currentDoc.rules = this.currentDoc.rules.filter(rule => rule.uuid !== uuid);
        },
        openBlockSettings({ name, uuid }) {
            const rule = this.getCurrentRule(uuid);
            if (rule) {
                const { name, uuid, description, statement, conditions } = rule;
                this.selectedBlock = {
                    name,
                    uuid,
                    description,
                    conditions: { statement, conditions }
                };
            } else {
                this.selectedBlock = {
                    name,
                    uuid,
                    description: "",
                    conditions: {
                        statement: "",
                        conditions: []
                    }
                };
            }

            this.showModal = true;
        },
        openRepeatableBlockSettings({ name, uuid, parentUuid }) {
            const repBlock = this.getCurrentRepeatable(uuid);
            if (repBlock) {
                const { selection, sortBy, direction, statement, conditions } = repBlock;
                this.selectedRepeatableBlock = {
                    name,
                    uuid,
                    parentUuid,
                    selection,
                    sortBy,
                    direction,
                    conditions: { statement, conditions }
                };
            } else {
                this.selectedRepeatableBlock = {
                    name,
                    uuid,
                    parentUuid,
                    selection: [],
                    sortBy: "",
                    direction: "",
                    conditions: {
                        statement: "",
                        conditions: []
                    }
                };
            }
            this.getdataModelConstraint();
            this.showRepeatableModal = true;
        },
        deleteRepeatableConfig(uuid) {
            if (!this.currentDoc.repeatableParameters) {
                this.currentDoc.repeatableParameters = [];
            }
            this.currentDoc.repeatableParameters = this.currentDoc.repeatableParameters.filter(config => config.uuid !== uuid);
        },
        changePageLayout(newFormat) {
            this.pageFormat = newFormat;
            return this.pageFormat;
        },
        toggleShowBlocks() {
            this.showBlocks = !this.showBlocks;
            return this.showBlocks;
        },
        insertTable([ev]) {
            this.$emit("addDataTable");
            this.tablePickerOpen = false;
            return addDataTable(ev, froalaInstance);
        },
        onModelSelect(item) {
            froalaInstance.selection.restore();
            const newElement = formatDataModelVar(item);
            if (this.currentBeforeBlur) {
                tribute.current = this.currentBeforeBlur;
            }
            tribute.range.replaceTriggerText(newElement, false, false, {}, {});
            tribute.isActive = false;
            tributeInterface.showVariables = false;
            froalaInstance.events.focus();
        },
        refreshMenuPosition() {
            const menuHeight = 300;
            const menuWidth = 320;
            const windowHeight = window.innerHeight;
            const windowWidth = window.innerWidth;
            const selectionX = froalaInstance.position.getBoundingRect().x;
            const selectionY = froalaInstance.position.getBoundingRect().y;
            this.offsetY = selectionY + 20;
            this.offsetX = selectionX;
            if (selectionY > windowHeight / 2) {
                this.offsetY = selectionY - menuHeight - 10;
            }
            if (selectionX > windowWidth - 350) {
                this.offsetX = selectionX - menuWidth;
            }
        },
        exitFullscreen() {
            if (froalaInstance.fullscreen.isActive()) {
                froalaInstance.fullscreen.toggle();
            }
        }
    }
};
